import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { FunilClient } from "@/client/modules/funil/funil-client";
import Loading from "@/client/modules/funil/loading";

export const Route = createFileRoute("/app/funil")({
  loader: ({ context }) => ensurePage(context.queryClient, apiQuery("funil", "page", {})),
  head: () => pageHead("Funil de captação"),
  pendingComponent: Loading,
  component: FunilPage,
});

function FunilPage() {
  const { data } = useApiSuspenseQuery("funil", "page", {});
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader
        title="Funil de captação"
        description="Do primeiro contato à ficha de paciente — com a próxima ação sempre marcada."
      />
      <FunilClient {...data} />
    </div>
  );
}
